import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../services/api';
import { textoPrueba } from '../utils/planes';

// Franja bajo el navbar mientras dura la prueba de 14 días de Pro.
export default function TrialBanner() {
  const [dias, setDias] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let vivo = true;
    api.get('/planes/mi-plan', { skipAuthRedirect: true })
      .then(res => { if (vivo) setDias(res.data?.en_prueba ? res.data.dias_prueba_restantes : null); })
      .catch(() => { if (vivo) setDias(null); });
    return () => { vivo = false; };
  // Se vuelve a consultar al cambiar de sección: al pagar, la franja desaparece sola
  }, [location.pathname]);

  if (dias === null || location.pathname === '/planes') return null;

  return (
    <div role="status" className="bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 text-amber-900 dark:text-amber-200 text-sm px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
      <span className="font-semibold">{textoPrueba(dias)}</span>
      <Link to="/planes" className="font-semibold underline hover:no-underline">
        Elegir plan →
      </Link>
    </div>
  );
}
